import React from 'react'
import PropTypes from 'prop-types'

import { Redirect, Route, Switch } from 'react-router-dom'

import Error from './Error'
import Home from './home/Home'
import Loading from './loading/Loading'
import Login from './login/Login'

class Main extends React.Component {

  render() {
    const { handleAuthentication, handleLogin, handleLogout, handleRefreshProfile,
      isAuthenticated, isSetup, apiKey, clientId, profile } = this.props
    return (
      <Switch>
        <Route exact path='/error' render={props => <Error {...props} />} />
        <Route exact path='/callback' render={props => {
          handleAuthentication(props)
          return <Loading {...props} />
        }} />
        <Route exact path='/login' render={props => <Login handleLogin={handleLogin} />} />
        <Route path='/' render={props =>
          !isAuthenticated
            ? <Redirect to='/login' />
            : <Home
                apiKey={apiKey}
                clientId={clientId}
                profile={profile}
                handleRefreshProfile={handleRefreshProfile}
                handleLogout={handleLogout}
                isAuthenticated={isAuthenticated}
                isSetup={isSetup}
              />
        } />
      </Switch>
    )
  }
}

Main.propTypes = {
  handleAuthentication: PropTypes.func.isRequired,
  handleLogin: PropTypes.func.isRequired,
  handleLogout: PropTypes.func.isRequired,
  handleRefreshProfile: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  isSetup: PropTypes.bool.isRequired,
  apiKey: PropTypes.string.isRequired,
  clientId: PropTypes.string.isRequired,
  profile: PropTypes.object.isRequired
}

export default Main
